import { render } from "./ApprovedBills.vue?vue&type=template&id=1206f9cc&scoped=true"
import script from "./ApprovedBills.vue?vue&type=script&lang=js"
export * from "./ApprovedBills.vue?vue&type=script&lang=js"

import "./ApprovedBills.vue?vue&type=style&index=0&id=1206f9cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1206f9cc"]])

export default __exports__